import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import { VarHelper } from "common-import/helpers";

export default class UploadVideoModal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    list: PropTypes.array,
  };

  constructor(props) {
    super (props);

    this.state = {
      open: false,
      input: '',
      videos: [],
    };

    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    // this.handleRemove = this.handleRemove.bind(this, 'index');
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleAdd = (e) => {
    e.preventDefault();
    const { videos, input } = this.state;
    if (!input) return null;
    this.setState({
      videos: [...videos, input]
    });
    this.setState({ input: '' });
  };

  handleRemove = (index) => {
    // e.preventDefault();
    const { videos } = this.state;
    const clone = videos.filter((item, key) => {
      if (index !== key) {
        return item;
      }
    });
    this.setState({ videos: clone });
  };

  handleInputChange = (e) => {
    this.setState({ input: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { videos } = this.state;
    this.props.onSubmit(videos);
  };

  onClose = () => {
    this.setState({ open: false });
    this.props.onClose();
  };

  componentDidUpdate(prevProps) {
    const { open, list } = this.props;
    if (open !== prevProps.open) {
      this.setState({
        open,
        videos: [...list],
      })
    }
  }

  render() {
    const classCustom = {
      "modal": "modal-custom upload-video-modal",
      "closeButton": "close-button-custom",
    };

    const { videos, input } = this.state;

    const renderPreview = () => {
      return videos.map((item, index) => {
        return <div key={index + 'video'} className="col-md-6 video-block">
            <div className="embed-container">
              <iframe src={VarHelper.toEmbedYoutube(item)} frameBorder="0" allowFullScreen> </iframe>
            </div>
            <button onClick={this.handleRemove.bind(this, index)} className="btn btn-sm btn-danger">Remove this video</button>
        </div>
      })
    };

    return (
      <Modal classNames={classCustom} open={this.state.open} onClose={this.onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Upload video</h5>
          </div>
          <div className="modal-body">
            <div className="input-group">
              <input value={input} onChange={this.handleInputChange} type="text" placeholder="Video url" className="form-control" />
              <div className="input-group-append">
                <button onClick={this.handleAdd} type="button" className="btn btn-primary">Add</button>
              </div>
            </div>
            <div className="row preview">
              {renderPreview()}
            </div>
          </div>
          <div className="modal-footer">
            <button onClick={this.onSubmit} className="btn btn-sm btn-primary">
              <i className="fa fa-dot-circle-o"> </i> Save
            </button>
            <button onClick={this.onClose} className="btn btn-sm btn-secondary">
              <i className="fa fa-ban"> </i> Close
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}




// WEBPACK FOOTER //
// ./src/custom/UploadVideoModal.js